import React, { useState } from 'react';
import { useAssignmentContext } from '../../../context';
import {
  faChevronRight,
  faKey,
  faList,
  faHistory,
  faSwatchbook
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DropDown from '../../../../../../src/components/DropDown';
import CustomToast from '../../../../../../src/components/Toast';
import Modal from '../../../../../components/Modal';
import {
  useRenameAssignmentMutation,
  useUpdateTeacherNoteMutation,
  useReclassifyCourseMutation,
  useSetMcStyleMutation,
  useGetAnswerHistoryMutation,
  useGetAssignmentPropertiesMutation,
  useGetQuestionPropertiesMutation
} from '../../../../../features/authentication/assignmentApislice';
import PropTypes from 'prop-types';
import { useGetAllCourseListMutation } from '../../../../../features/authentication/authApiSlice';
import { useEffect } from 'react';
import ConfirmationModal from '../../../../../components/ConfirmationPopUp';
import { Link } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import ViewCoTeachersModal from './modals/ViewCoTeachersModal';
import QuestionPropertiesModal from '../../../../questionsSearch/components/castleQuestionsSearch/components/QuestionPropertiesModal';
import PropertiesModal from '../../../components/PropertiesModal';
import { useGetCoTeachersByAssignmentMutation } from '../../../../../features/authentication/assignApiSlice';

const EditAssignmentOptionsModal = ({
  assignmentInfo,
  setQuestions,
  selectedMcStyle,
  setSelectedMcStyle,
  selectedLanguage,
  setSelectedLanguage,
  setIsLanguageChanged,
  mcChoices,
  currentQuestionId,
  questionCourseId,
  isBlockedQuestion
}) => {
  const { assignmentId, setAssignmentCourseId } = useAssignmentContext();
  const selectedAssignment = useAssignmentContext();
  const [isModifyOpen, setIsModifyOpen] = useState(true);
  const [assignmentEditName, setAssignmentEditName] = React.useState('');
  const [collaboratorsOpen, setCollaboratorsOpen] = useState(false);
  const [propertiesOpen, setPropertiesOpen] = useState(false);
  const [displayPrintOpen, setDisplayPrintOpen] = useState(true);
  const [renameAssignment] = useRenameAssignmentMutation();
  const [contentNote, setContentNote] = useState('');
  const [noteDescription, setNoteDescription] = useState('');
  const [teacherNoteModel, setTeacherNoteModel] = useState(false);
  const [updateTeacherNote] = useUpdateTeacherNoteMutation();
  const [reclassifyModel, setReclassifyModel] = useState(false);
  const [getAllCourses] = useGetAllCourseListMutation();
  const [allCourses, setAllCourses] = useState('');
  const [selectedCourseId, setSelectedCourseId] = useState('');
  const [reclassifyCourse] = useReclassifyCourseMutation();
  const [confirmModel, setConfirmModel] = useState(false);
  const [setMcStyle] = useSetMcStyleMutation();
  const [getAnswerHistory] = useGetAnswerHistoryMutation();
  const [allAnswerHistory, setAllAnswerHistory] = useState([]);
  const [answerHistoryModel, setAnswerHistoryModel] = useState(false);
  const [collaboratorModal, setCollaboratorModal] = useState(false);
  const [openAssignmentProperties, setOpenAssignmentProperties] = useState(false);
  const [assignmentProperties, setAssignmentProperties] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [getAllAssignmentProperties] = useGetAssignmentPropertiesMutation();
  const [getQuestionProperties] = useGetQuestionPropertiesMutation();
  const [getCoteachers] = useGetCoTeachersByAssignmentMutation();
  const [showQuestionPropertiesModal, setShowQuestionPropertiesModal] = useState(false);
  const [propertiesResult, setPropertiesResult] = useState({});
  const [coteachers, setCoteachers] = useState([]);
  const [isCoteacherLoading, setIsCoteacherLoading] = useState(false);

  const languages = [
    {
      id: 0,
      name: 'English Only'
    },
    {
      id: 1,
      name: 'Spanish if available'
    }
  ];

  React.useEffect(() => {
    setAssignmentEditName(assignmentInfo.assignmentName);
    setSelectedCourseId(assignmentInfo.courseId);
    selectedAssignment.setAssignmentCourseId(assignmentInfo.courseId);
    selectedAssignment.setAssignmentName(assignmentInfo.assignmentName);
    selectedAssignment.setAssignmentId(assignmentInfo.assignmentId);
  }, [assignmentInfo]);

  const changeAssignmentName = async (value) => {
    try {
      let option = {
        assignmentId: assignmentId,
        assignmentName: value
      };
      const response = await renameAssignment(option);
      if (response.error) {
        CustomToast(response.error.data.error, 'error');
      } else {
        let updatedInfo = { ...assignmentInfo, assignmentName: value };
        setQuestions(updatedInfo);
        selectedAssignment.setAssignmentName(value);
        CustomToast('Assignment name changed successfully', 'success');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAssignmentEdit = (event) => {
    setAssignmentEditName(event.target.value);
  };

  const handleOutsideClick = (event) => {
    if (
      event.target.value.includes('\\') ||
      event.target.value.includes('/') ||
      event.target.value.includes('<') ||
      event.target.value.includes('>')
    ) {
      CustomToast('Input cannot contain "\\" or "<" symbols', 'warning');
    } else if (event.target.value.trim().length === 0)
      CustomToast('Assignment name cannot be empty', 'warning');
    else if (assignmentInfo.assignmentName == assignmentEditName) return;
    else changeAssignmentName(event.target.value);
  };

  const teacherNoteDescription = (event) => {
    setContentNote(event.target.value);
    setNoteDescription(event.target.value);
  };

  const saveNote = async () => {
    try {
      const options = {
        assignmentId: assignmentId,
        assignmentNote: noteDescription
      };
      const response = await updateTeacherNote(options);
      if (response.error) {
        CustomToast(response.error.data.error, 'error');
        setTeacherNoteModel(false);
      } else {
        let updatedInfo = { ...assignmentInfo, assignmentNote: noteDescription };
        setQuestions(updatedInfo);
        CustomToast('Assignment Note saved successfully', 'success');
        setTeacherNoteModel(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCoursesAsync();
  }, []);

  const getAllCoursesAsync = async () => {
    try {
      const allCoursesResponse = await getAllCourses().unwrap();
      allCoursesResponse !== null && allCoursesResponse !== undefined;
      setAllCourses(allCoursesResponse);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectCourse = (event) => {
    const selectedCourseId = parseInt(event.target.value);
    setSelectedCourseId(selectedCourseId);
  };

  const saveCourse = async () => {
    const options = {
      assignmentId: assignmentId,
      courseId: selectedCourseId
    };
    if (selectedCourseId === selectedAssignment.assignmentCourseId) {
      CustomToast('Cannot be reclassified to the same course.', 'warning');
      setConfirmModel(false);
      setReclassifyModel(false);
    } else {
      try {
        const response = await reclassifyCourse(options);
        if (response.error) {
          CustomToast(response.error.data.error, 'error');
          setConfirmModel(false);
          setReclassifyModel(false);
        } else {
          const selectedCourse = allCourses.filter((item) => item.id === selectedCourseId);
          if (selectedCourse.length > 0) {
            let updatedInfo = { ...assignmentInfo, courseName: selectedCourse[0].name, courseId: selectedCourseId };
            setQuestions(updatedInfo);
          }
          setAssignmentCourseId(selectedCourseId);
          CustomToast('Assignment reclassfied to new course', 'success');
          setConfirmModel(false);
          setReclassifyModel(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleMcStyle = (event) => {
    const selectedMcStyleId = parseInt(event.target.value);
    setSelectedMcStyle(selectedMcStyleId);
    setMcStyleOption(selectedMcStyleId);
  };

  const setMcStyleOption = async (mcstyle) => {
    try {
      let option = {
        assignmentId: assignmentId,
        mcStyle: mcstyle
      };
      const response = await setMcStyle(option);
      if (response.error) {
        CustomToast(response.error.data.error, 'error');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAnswerHistory = async () => {
    const options = {
      assignmentId: assignmentId
    };
    const response = await getAnswerHistory(options);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
    }
    else {
      setAllAnswerHistory(response.data);
      setAnswerHistoryModel(true);
    }
  };

  const handleLanguage = (event) => {
    const selectedlanguageId = parseInt(event.target.value);
    setIsLanguageChanged(true);
    setSelectedLanguage(selectedlanguageId);
  };

  const handlePrintPdf = async () => {
    // Generate the PDF from the HTML content
    const contentWrapper = document.getElementById('answer-history-pdf');
    const contentClone = contentWrapper.cloneNode(true);

    const buttonGroup = contentClone.querySelector('#answer-history-header');
    buttonGroup.classList.remove('d-none');

    const tables = contentClone.getElementsByTagName('table');

    // Apply CSS styles to tables
    for (let i = 0; i < tables.length; i++) {
      const table = tables[i];
      table.style.pageBreakInside = 'avoid';
      table.style.breakInside = 'avoid';
      table.style.keepWithWindow = 'always';
    }

    const options = {
      margin: 40, // Specify the margin for all sides (top, right, bottom, left)
      filename: 'answer-history.pdf', // Specify the desired filename
      image: { type: 'jpeg', quality: 0.98 }, // Set the image type and quality (optional)
      html2canvas: { scale: 3 }, // Set the scale for better quality (optional)
      jsPDF: { unit: 'pt', format: 'a2', orientation: 'portrait' } // Set the document format and orientation (optional)
    };

    await html2pdf().set(options).from(contentClone).save(`${assignmentInfo.assignmentName}.pdf`);
  };

  const handleAssignmentProperties = () => {
    setOpenAssignmentProperties(true);
    getAllAssignmentPropertiesAsync();
  };

  const getAllAssignmentPropertiesAsync = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const option = {
          assignmentId: assignmentId
        };
        const allAssignmentsPropertiesResponse = await getAllAssignmentProperties(
          option
        );
        if (allAssignmentsPropertiesResponse.error) {
          CustomToast(allAssignmentsPropertiesResponse.error.data.error, 'error');
        }
        else {
          setAssignmentProperties(allAssignmentsPropertiesResponse.data);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    }
  };

  const handleQuestionProperties = () => {
    getAllQuestionPropertiesAsync();
    setShowQuestionPropertiesModal(true);
  };

  const getAllQuestionPropertiesAsync = async () => {
    if (!isLoading) {
      setIsLoading(true);
      try {
        const options = {
          questionId: currentQuestionId,
          assignmentId: assignmentId,
          courseId: questionCourseId
        };
        const allQuestionPropertiesResponse = await getQuestionProperties(
          options
        );
        if (allQuestionPropertiesResponse.error) {
          CustomToast(allQuestionPropertiesResponse.error.data.error, 'error');
        }
        else {
          setPropertiesResult(allQuestionPropertiesResponse);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.log(error);
      }
    }
  };

  const manageViewCollaborator = async () => {
    setCollaboratorModal(true);
    setIsCoteacherLoading(true);
    try {
      let paramIds = [assignmentId];
      const options = {
        assignmentIds: paramIds
      };
      const allCoTeachers = await getCoteachers(options).unwrap();
      allCoTeachers.length > 0 ?
        setCoteachers(allCoTeachers[0].coTeachers) :
        setCoteachers([]);
    } catch (error) {
      console.log(error);
    }
    setIsCoteacherLoading(false);
  };

  return (
    <>
      <div className="mt-3 classroom-content">
        <div className={`classroom-content-box ${isModifyOpen && 'open'}`}>
          <div className="classroom-content-header justify-content-between align-item-center d-flex">
            <h6>Modify Assignment</h6>
            <button onClick={() => setIsModifyOpen(!isModifyOpen)} className="z-index10 grey-clr">
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          {isModifyOpen && (
            <div>
              <div>
                <div>Rename the assignment</div>
                <div>
                  <input
                    className="form-control content-print"
                    value={assignmentEditName}
                    onChange={handleAssignmentEdit}
                    onBlur={handleOutsideClick}
                  />
                </div>
              </div>
              <div className="mt-2">
                <DropDown
                  label="Multiple Choice Style"
                  value={mcChoices}
                  selectedValue={selectedMcStyle}
                  description={true}
                  onChangeHandler={(e) => handleMcStyle(e)}
                />
              </div>
              <div className="d-flex">
                <button
                  className={'btn btn-castleWhite mr-2 mt-3 py-2 h-auto'}
                  onClick={() => {
                    setTeacherNoteModel(true);
                    setContentNote(assignmentInfo.assignmentNote);
                  }}>
                  {assignmentInfo.assignmentNote === null || assignmentInfo.assignmentNote === ''
                    ? ' Create Assignment Note'
                    : 'Edit Assignment Note'}
                </button>
                <button
                  className={'btn btn-castleWhite mt-3 py-2 h-auto'}
                  onClick={() => setReclassifyModel(true)}>
                  Reclassify to Another Course
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="line"></div>
      <div className="mt-3 classroom-content">
        <div className={`classroom-content-box ${collaboratorsOpen && 'open'}`}>
          <div className="classroom-content-header justify-content-between align-item-center d-flex">
            <h6>Manage Access</h6>
            <button
              className="z-index10 grey-clr"
              onClick={() => setCollaboratorsOpen(!collaboratorsOpen)}>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          {collaboratorsOpen && <button
            className={'btn btn-castleWhite mt-3 py-2 h-auto w-100'}
            onClick={() => manageViewCollaborator()}>
            View / Edit Collaborators
          </button>}
        </div>
      </div>
      <div className="line"></div>
      <div className="mt-3 classroom-content">
        <div className={`classroom-content-box ${propertiesOpen && 'open'}`}>
          <div className="classroom-content-header justify-content-between align-item-center d-flex">
            <h6>Properties</h6>
            <button
              className="z-index10 grey-clr"
              onClick={() => setPropertiesOpen(!propertiesOpen)}>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          {propertiesOpen && <div className="d-flex">
            <button
              className={`btn btn-castleWhite mr-2 mt-3 py-2 h-auto w-50 ${isBlockedQuestion && 'disabled'}`}
              onClick={() =>
                handleQuestionProperties()
              }>
              Question
            </button>
            <button
              className={'btn btn-castleWhite mt-3 py-2 h-auto w-50'}
              onClick={() => handleAssignmentProperties()}>
              Assignment
            </button>
          </div>}
        </div>
      </div>
      <div className="line"></div>
      <div className="mt-3 w-100">
        <div className="mt-3 classroom-content">
          <div className={`classroom-content-box ${displayPrintOpen && 'open'}`}>
            <div className="classroom-content-header justify-content-between align-item-center d-flex">
              <h6>Display/Print</h6>
              <button
                className="z-index10 grey-clr"
                onClick={() => setDisplayPrintOpen(!displayPrintOpen)}>
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
            {displayPrintOpen && (
              <div>
                <div className="mt-3">
                  <DropDown
                    label="Language"
                    value={languages}
                    selectedValue={selectedLanguage}
                    description={true}
                    onChangeHandler={(e) => handleLanguage(e)}
                  />
                </div>
                <div className="d-flex mt-3">
                  <Link
                    className="d-flex align-items-center text-decoration-none text-body cursor-pointer mr-2 w-50"
                    data-end="true"
                    to={`/assignments/${assignmentId}/standardPrinting`}
                    state={{ assignmentId: assignmentId, assignmentName: assignmentEditName }}>
                    <span className="blue-icon align-content-center">
                      <FontAwesomeIcon icon={faSwatchbook} className="px-1" />
                    </span>
                    Assignment
                  </Link>
                  <Link
                    className="d-flex align-items-center text-decoration-none text-body cursor-pointer w-50"
                    data-end="true"
                    to={`/assignments/${assignmentId}/vocabularyPrinting`}
                    state={{ assignmentId: assignmentId, assignmentName: assignmentEditName }}>
                    <span className="blue-icon align-content-center">
                      <FontAwesomeIcon icon={faList} className="px-1" />
                    </span>
                    Vocabulary
                  </Link>
                </div>
                <div className="d-flex mt-3">
                  <Link
                    className="d-flex align-items-center text-decoration-none text-body cursor-pointer mr-2 w-50"
                    data-end="true"
                    to={`/assignments/${assignmentId}/answerKey`}
                    state={{ assignmentId: assignmentId, assignmentName: assignmentEditName }}>
                    <span className="blue-icon align-content-center">
                      <FontAwesomeIcon icon={faKey} className="px-1" />
                    </span>
                    Answer Key
                  </Link>
                  <div className="d-flex align-items-center cursor-pointer w-50" onClick={() => handleAnswerHistory()}>
                    <span className="blue-icon align-content-center">
                      <FontAwesomeIcon icon={faHistory} className="px-1" />
                    </span>
                    Answer History
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal
        contentWidth="600px"
        isOpen={teacherNoteModel}
        titleName={'Teacher Notes'}
        onClose={() => setTeacherNoteModel(false)}>
        <textarea
          type="text"
          className="form-control textarea-lg"
          placeholder=" "
          name="noteDescription"
          id="noteDescription"
          value={contentNote}
          onChange={teacherNoteDescription}
        />
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => {
              setContentNote('');
              setNoteDescription('');
            }}>
            Clear
          </button>
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => setTeacherNoteModel(false)}>
            Cancel
          </button>
          <button className="btn btn-castleRed print-btn" onClick={() => saveNote()}>
            Save
          </button>
        </div>
      </Modal>
      <Modal
        contentWidth="600px"
        isOpen={reclassifyModel}
        titleName={'Reclassify Assignment To a Different Course'}
        onClose={() => {
          setReclassifyModel(false);
          setSelectedCourseId(assignmentInfo.courseId);
        }}
        titleToolTip={
          'All assignments are categorized to a Castle Learning course, regardless of the original source of the questions that you have included. Because students select assignments based on the associated course, you should select the course most closely associated with the questions.'
        }>
        <DropDown
          key={'all-course-list'}
          label="Select Course"
          value={allCourses}
          onChangeHandler={(e) => handleSelectCourse(e)}
          selectedValue={selectedCourseId}
        />
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => {
              setReclassifyModel(false);
              setSelectedCourseId(assignmentInfo.courseId);
            }}>
            Cancel
          </button>
          <button className="btn btn-castleRed print-btn" onClick={() => setConfirmModel(true)}>
            Save
          </button>
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        onSave={() => saveCourse()}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={'Are you sure that you want to reclassify the assignment to the selected course?'}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      <Modal
        contentWidth="700px"
        isOpen={answerHistoryModel}
        titleName={`Answer History for : ${assignmentEditName}`}
        onClose={() => setAnswerHistoryModel(false)}>
        <div id='answer-history-pdf'>
          <h3 id='answer-history-header' className='d-none mb-2'>Answer History for : {assignmentEditName}</h3>
          <div>
            The following table shows the number of correct and incorrect responses for each of the
            assessment&apos;s/assignment&apos;s questions by students in all of your classes. This includes
            responses from any assignment (including any retakes) in which the questions have been
            used. Only the results of assigned questions are included - not the results from
            self-generated students sessions.
          </div>
          <table className="table list-table mt-4">
            <thead>
              <th className="text-center">Question</th>
              <th className="text-center">Correct</th>
              <th className="text-center">Incorrect</th>
            </thead>
            <tbody>
              {allAnswerHistory.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="text-center">
                      {index + 1}
                    </td>
                    {item.questionType === 3?(
                      <>
                        <td className="text-center" colSpan={2}>{'Constructed Response(CR)'}</td>
                      </>):(
                      <>
                        <td className="text-center">{item.correct}</td>
                        <td className="text-center">{item.incorrect}</td>
                      </>)
                    }
                    
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => setAnswerHistoryModel(false)}>
            Close
          </button>
          <button className="btn btn-castleRed print-btn" onClick={handlePrintPdf}>Print</button>
        </div>
      </Modal>
      {collaboratorModal && (
        <ViewCoTeachersModal modalData={collaboratorModal} 
          onClose={() => setCollaboratorModal(false)}
          setModalData={setCollaboratorModal} 
          fromMoreActions={true}
          coteachers={coteachers}
          setCoteachers={setCoteachers}
          coTeachersDataLoading={isCoteacherLoading}
        />
      )}
      {openAssignmentProperties &&
      <PropertiesModal
        title={assignmentInfo.assignmentName}
        properties={assignmentProperties}
        isLoading={isLoading}
        openProperties={openAssignmentProperties}
        setOpenProperties={setOpenAssignmentProperties}
        assignmentId = {assignmentInfo.assignmentId}
        isPublicAssignment={false}
      /> 
      }
      {showQuestionPropertiesModal &&
        <QuestionPropertiesModal
          setShowQuestionPropertiesModal={setShowQuestionPropertiesModal}
          showQuestionPropertiesModal={showQuestionPropertiesModal}
          propertiesResult={propertiesResult}
          setPropertiesResult={setPropertiesResult}
          isSearchQuestion={false}
          isLoading={isLoading}
        />
      }
    </>
  );
};

EditAssignmentOptionsModal.propTypes = {
  assignmentInfo: PropTypes.object,
  setQuestions: PropTypes.func,
  selectedMcStyle: PropTypes.number,
  setSelectedMcStyle: PropTypes.func,
  selectedLanguage: PropTypes.number,
  setSelectedLanguage: PropTypes.func,
  setIsLanguageChanged: PropTypes.func,
  mcChoices: PropTypes.array,
  currentQuestionId: PropTypes.number,
  questionCourseId: PropTypes.number,
  isBlockedQuestion: PropTypes.bool
};

export default EditAssignmentOptionsModal;
